import {
  Box,
  Flex,
  Text,
  Image as ImageComponent,
  List,
  Button,
  useToast,
  Icon,
  Tooltip,
  AccordionButton,
  AccordionPanel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Alert,
  AlertIcon,
  IconButton,
} from "@chakra-ui/react";
import {
  CheckIcon,
  ArrowForwardIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  InfoIcon,
} from "@chakra-ui/icons";
import Image from "next/legacy/image";
import {
  StarSpan,
  StarFlexer,
  StarContainer,
  StickyReviews,
  ReviewLogo,
  StarsHolder,
  ReviewRightSide,
  RightSideTop,
  RatingHolder,
  MiniLogo,
} from "../styles/LPStyles";
import React, { useEffect, useState, useRef } from "react";
import Head from "next/head";
import Link from "next/link";
import { useAuth } from "../utils/auth/newAuth";
import { AuthModal } from "../components/Auth/withAuthModal";
import { useMutation } from "react-query";
import * as Sentry from "@sentry/nextjs";
import { getToken } from "../src/config/firebase";
import { DashedDivider, DemoLink, MyListItem } from "../styles/PricingStyles";
import styles from "../styles/pricing.module.css";
import { BsLightningChargeFill } from "react-icons/bs";
import { AiFillStar } from "react-icons/ai";
import { plansFAQ } from "../data/faq";
import * as S from "../styles/ProStyles";
import { WrapperStyle } from "../styles/newDesignStyles";
import useWindowSize from "../components/Utility/windowSize";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import {
  ContactInput,
  ContactTextArea,
} from "../components/UI/Forms/Input/Input";
import { PrimaryButton } from "../components/button";
import Carousel from "react-elastic-carousel";
import Message from "../components/UI/Message/Message";
import { IconType } from "react-icons/lib";
import { clientAnalytics, clientError } from "../utils/utilties";
import { currentPriceCodes, currentPrices } from "../data/prices";
import type { ComponentType } from "react";

const ElasticCarousel = Carousel as unknown as ComponentType<any>;

const Plans = () => {
  const toast = useToast();
  const { user, profile, userId } = useAuth();
  const [isProAlert, setIsProAlert] = useState(false);
  const [isAuthBoxOpen, setIsAuthBoxOpen] = useState(false);
  const size = useWindowSize();
  const [messageStatus, setMessageStatus] = useState("idle");

  const [authHeader, setAuthHeader] = useState(undefined);
  // Partial of ./components/CheckoutForm.tsx
  // ...
  const [loading, setLoading] = useState(null);
  const [checkoutPending, setCheckoutPending] = useState(false);
  const [checkoutPrice, setCheckoutPrice] = useState(null);
  const [planInterval, setPlanInterval] = useState("annual");
  const [visibleAccordionIndex, setVisibleAccordionIndex] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();


  /* 
  Screen sizes
  */
  const isOnSmallScreen = size.width < 520;
  const isOnMediumScreen = size.width > 520 && size.width <= 1040;
  const isOnLargeScreen = size.width > 1040;

  // const [input, setInput] = useState({
  //     customDonation: Math.round(config.MAX_AMOUNT / config.AMOUNT_STEP),
  // })


  useEffect(() => {
    if (profile && checkoutPending) {
      checkoutMutation.mutate({
        lookup_key: checkoutPrice,
        email: profile?.email,
        stripeId: profile?.stripeId,
      });
    }
  }, [profile]);

  const myRef = useRef(null);

  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: "smooth" });

  async function createCheckoutRequest(checkoutData) {
    setLoading(checkoutData["plan"]);
    // setCreateStatus('loading')
    checkoutPending ? setCheckoutPending(false) : null;
    checkoutPrice ? setCheckoutPrice(null) : null;
    const response = await fetch("/api/checkout_sessions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
        userId: userId,
      },
      body: JSON.stringify({ ...checkoutData }),
    });

    const data = await response.json();
    const { url } = data;

    return url;
  }

  const checkoutMutation = useMutation(createCheckoutRequest, {
    onError: (error) => {
      setLoading(null);

      clientError(error);
    },

    onSuccess: async (url) => {
      if (url) {
        window.location.href = url;
      } else {
        toast({
          title: "Error",
          description: "Something went wrong. Please try again later.",
          status: "error",
          duration: 5000,
        });

        clientError(new Error("Checkout creation failed"));
        setLoading(null);
      }
    },
    onSettled: () => {
      // setCreateStatus('idle');
      // setSavedSearchPending(false);
      // setUnauthSavedSearchPending(false);
    },
  });

  const TooltipCreator = ({ label }) => {
    return (
      <span style={{ verticalAlign: "inherit", display: "inline" }}>
        <Tooltip
          aria-label={label}
          label={label}
          // display={{base:"none", xs: "block"}}
          // placement="right-end"
          paddingY={"6px"}
          fontFamily={"Inter, sans-serif"}
          zIndex={10}
        >
          <InfoIcon marginLeft="5px" mb="3px" />
        </Tooltip>
      </span>
    );
  };
  const triggerAuth = ({ hook, header, ...rest }) => {
    // Mixpanel.track(hook, { "Listing": id });
    clientAnalytics.track("Sign up attempted", {
      hook,
      ...rest,
    });

    setAuthHeader(header);
    setIsAuthBoxOpen(true);
  };

  // Step 2: Add `CustomRadio` as children of `RadioButtonGroup`

  const currentPlanText = (
    <Text className={styles.planComment}>Current Plan</Text>
  );

  const currentPlanTextWhite = (
    <Text className={styles.planCommentWhite}>Current Plan</Text>
  );
  // ...

  const userData = [
    {
      image: "/images/pro/adel-sheikh-amin.png",
      testimonial:
        "Great site and exposure. As a realtor, I am always looking for alternative ways to market my clients' listings, targeting a wider audience. As a buyer, there are many opportunities that are not listed hence a great way to gain access to them.",
      info: (
        <>
          Adel Sheikh Amin <br /> Sales Representative, Coldwell Banker Realty
          In Motion, Brokerage
        </>
      ),
    },
    {
      image: "/images/pro/marie-canonaco.svg",
      testimonial:
        "Very helpful platform providing excellent filters to help sort through inventory to help me find the best fit for my client.",
      info: (
        <>
          Marie Canonaco <br /> Salesperson, Remax Realty West Inc
        </>
      ),
    },
    // {
    //   image: "/images/pro/chamkaur-singh-sandhu.jpg",
    //   testimonial:
    //     "It's very well designed, with flexible filters, and easy to use. I am very satisfied with it. It is already become a go to website for my real estate needs in Canada. I recommend you go on Zonado regularly.",
    //   info: (
    //     <>
    //       Chamkaur Singh Sandhu <br /> Salesperson, International Realty Firm
    //       Inc. Brokerage
    //     </>
    //   ),
    // },
  ];

  const accordionData = [
    "/images/pro/unlock-full.png",
    "/images/pro/access-significantly.png",
    "/images/pro/unlock-PRO.png",
  ];
  const accordionBoxShadow =
    "0px 54px 37px 12px rgba(0,0,0,0.1), 0px 10px 15px -4px rgba(0,0,0,0.18)";

  const ResponsiveAccordionButton = (props: {
    buttonText: string;
    icon: IconType;
    accordionIndex: number;
  }) => {
    if (isOnLargeScreen) return null;

    return (
      <AccordionButton
        px="30px"
        pt="30px"
        pb={4}
        fontWeight={"semibold"}
        width="100%"
        display="block"
        _hover={{ color: "#125F3F" }}
        onClick={() => setVisibleAccordionIndex(props.accordionIndex)}
        color={visibleAccordionIndex === props.accordionIndex && "#125F3F"}
        _focus={{
          outline: "none",
        }}
      >
        {isOnSmallScreen ? (
          <Flex
            flexDir={"column"}
            alignItems="flex-start"
            justifyContent={"center"}
          >
            <Icon as={props.icon} w="20px" h="20px" />
            <Text
              mt="10px"
              fontSize={"16px"}
              lineHeight="23px"
              textAlign={"left"}
            >
              {props.buttonText}
            </Text>
          </Flex>
        ) : isOnMediumScreen ? (
          <Flex justifyContent={"flex-start"} alignItems="center">
            <Icon flex="0.5" as={props.icon} w="30px" h="30px" />
            <Text
              flex="3"
              fontSize={"19px"}
              lineHeight="23px"
              textAlign={"left"}
            >
              {props.buttonText}
            </Text>
          </Flex>
        ) : null}
      </AccordionButton>
    );
    // else if (isOnMediumScreen) {
    // }
    // else { // Large screens

    // }
  };

  const ResponsiveAccordionPanel = (props: {
    panelText: string;
    panelImage: string;
    accordionIndex: number;
    imageWidth: number;
    imageHeight: number;
  }) => {
    return (<>
      {isOnSmallScreen ? (
        <>
          <AccordionPanel
            fontSize={"16px"}
            lineHeight="24px"
            px="30px"
            pb="30px"
            pt="0"
          >
            <Box>
              <Text>{props.panelText}</Text>
              <Box as="button" mt="15px" onClick={onOpen}>
                <Text fontWeight={"medium"} as="span">
                  Upgrade now
                </Text>
                <ArrowForwardIcon />
              </Box>
            </Box>
          </AccordionPanel>
        </>
      ) : isOnMediumScreen ? (
        <>
          <AccordionPanel
            fontSize={"16px"}
            lineHeight="24px"
            px="30px"
            pb="30px"
            pt="0"
          >
            <Flex justifyContent={"space-between"} alignItems="center">
              <Box flex="0.5"></Box>
              <Box flex="3">
                <Text>{props.panelText}</Text>
                <Box as="button" mt="15px" onClick={onOpen}>
                  <Text fontWeight={"medium"} as="span">
                    Upgrade now
                  </Text>
                  <ArrowForwardIcon />
                </Box>
              </Box>
            </Flex>
          </AccordionPanel>
        </>
      ) : null}
      <AccordionPanel p="0" mb="-10px">
        <Image
          src={props.panelImage}
          // objectPosition={'center'}
          width={props.imageWidth}
          height={props.imageHeight}
          sizes="100vw"
          style={{
            width: "100%",
            height: "auto",
            objectFit: "contain"
          }} />
      </AccordionPanel>
    </>);
  };

  const userCarouselRef = useRef(null);
  const userCarouselTotalPages = 3;
  let userCarouselResetTimeout;
  const onNextUserStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      userCarouselRef.current.goTo(0);
    }
  };
  const onPrevUserStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      userCarouselRef.current.goTo(userData.length);
    }
  };

  const logoCarouselRef = useRef(null);
  const logoCarouselTotalPages = 5;
  let logoCarouselResetTimeout;
  const onNextPopStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      logoCarouselRef.current.goTo(0);
    }
  };
  const onPrevPopStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      logoCarouselRef.current.goTo(20);
    }
  };

  async function createLeadRequest(leadData) {
    setMessageStatus("loading");
    const response = await fetch("/api/contact-us", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ lead: leadData }),
    });

    const data = await response.json();
    const { message } = data;
    return message;
  }

  const mutation = useMutation(createLeadRequest, {
    onError: (error) => {
      // An error happened!
      setMessageStatus("error");
      toast({
        title: "Error",
        description: `An error occurred. Please email as us at hello@zonado.com instead.`,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    },

    onSuccess: (data, variables, context) => {
      if (data) {
        setMessageStatus("success");
      } else throw "error";
    },
  });

  const MessageSchema = Yup.object().shape({
    message: Yup.string()
      .max(1000, "Too long.")
      .required("A message is required."),

    email: Yup.string().email("Invalid email.").required("Email is required."),

    phone: Yup.string()
      .min(10, "Must be 10 digits long")
      .max(10, "Must be 10 digits long"),

    name: Yup.string().min(2).required("Name is required."),
  });

  return (<>
    <Head>
      <title key="title">Zonado Pro</title>
      <meta
        key="description"
        name="description"
        content="Unlock all exclusive features on Zonado with Zonado Pro."
      />
      <meta key="og:title" property="og:title" content="Zonado Pro" />
      <meta
        key="og:description"
        property="og:description"
        content="Unlock all exclusive features on Zonado with Zonado Pro."
      />
      <meta
        key="og:image"
        property="og:image"
        content="https://firebasestorage.googleapis.com/v0/b/goldmine-7d9f7.appspot.com/o/compressed%2FPro_1200x1200.png?alt=media&token=e85a0541-673b-4866-85b1-83276a7ce53f"
      />
      <link rel="canonical" href="https://zonado.com/pro" />
    </Head>
    {/* {isProAlert &&
              <Alert
                  justifyContent="center"
                  textAlign="center"
                  fontSize="16px"
                  lineHeight="24px"
                  status="success">
                  <AlertIcon />
                  You are currently a PRO member.
              </Alert>
          } */}
    <AuthModal
      header={authHeader}
      goTo={"/pricing"}
      onClose={() => setIsAuthBoxOpen(false)}
      isOpen={isAuthBoxOpen}
      noRedirect={true}
      
    />
    <S.HeroBanner>
      <WrapperStyle>
        <Box m="0 auto">
          <S.HeroBannerTitle>Zonado Pro</S.HeroBannerTitle>
          <S.HeroBannerHeader>
            "I have made this a mandatory tool for my team"
            <br />
            <span style={{ fontSize: "20px" }}>
              Jammilah Dixon-Keating, CEO at Property Nerds
            </span>
          </S.HeroBannerHeader>
        </Box>
        {/* <S.BannerImageContainer>
          <Image
            src="/images/pro/banner-image.png"
            width={"596px"}
            height="361px"
            quality={100}
            priority
          />
        </S.BannerImageContainer> */}
      </WrapperStyle>
    </S.HeroBanner>
    {/* Plan breakdown */}
    <Box px={"25px"} mt={"-500px"}>
      <Flex mb={"240px"} className={styles.planWrapper} ref={myRef}>
        {/* basic plan */}
        <Flex className={styles.essentialContainer}>
          <Text
            textAlign={{ base: "center", lg: "start" }}
            lineHeight={{ base: "26px", lg: "38px" }}
            mt={{ base: "10px", lg: "0px" }}
            className={styles.planTitle}
          >
            Basic
          </Text>

          <Box pt={"47px"}>
            <List spacing={6} color={"#35353F"} className={styles.allButLast}>
            <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/solid-black-check.svg"}
                  />
                  Upload unlimited listings
                </Flex>
                <TooltipCreator
                  label={
                    "Reach thousands of principals and agents nationwide on Zonado"
                  }
                />
              </MyListItem>
              <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/solid-black-check.svg"}
                  />
                  Receive your first 5 leads on your listings, free
                </Flex>
                <TooltipCreator
                  label={
                    "All queries about your listings will come directly to you via in-app messaging. The first 5 are free."
                  }
                />
              </MyListItem>
            <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/solid-black-check.svg"}
                  />
                  Create and receive listing alerts
                </Flex>
                <TooltipCreator
                  label={
                    "Save your search with the exact criteria of what you are looking for and receive alerts when matching listings are uploaded."
                  }
                />
              </MyListItem>

              <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/solid-black-check.svg"}
                  />
                  View listing analytics
                </Flex>
                <TooltipCreator
                  label={
                    "Gain negotiation power or adjust strategy with key insights on how your listing is performing on Zonado."
                  }
                />
              </MyListItem>

              {size.width >= 1040 ? (
                <>
                  <Text
                    fontSize={"20px"}
                    _hover={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={executeScroll}
                  >
                    See all features <ArrowForwardIcon />
                  </Text>
                </>
              ) : (
                <>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/solid-black-check.svg"}
                      />
                      Browse unlimited listings
                    </Flex>
                    <TooltipCreator
                      label={
                        "We do not charge users for browsing listings and do not restrict listing access for free users."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/solid-black-check.svg"}
                      />
                      Create saved searches
                    </Flex>
                    <TooltipCreator
                      label={
                        "Looking for a particular type of property or listing? Use the saved search functionality to make sure that you're alerted as soon as it hits Zonado."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/solid-black-check.svg"}
                      />
                      Filter for non-MLS® listings
                    </Flex>
                    <TooltipCreator
                      label={
                        "Zonado hosts listings that aren't publicly listed on the MLS® and you can easily filter for them."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/solid-black-check.svg"}
                      />
                      Email and chat support
                    </Flex>
                    <TooltipCreator
                      label={
                        "When you need any help with Zonado, we're here to assist you via email or chat."
                      }
                    />
                  </MyListItem>
                </>
              )}
            </List>
          </Box>
          <DashedDivider my={"20px"} />
          <Text
            textAlign={{ base: "center", lg: "start" }}
            lineHeight={{ base: "26px", lg: "38px" }}
            mt="12px"
            className={styles.planTitle}
          >
            Free always
          </Text>
          {user && !profile?.pro ? currentPlanText : null}
          {!user && (
            <Button
              onClick={() => setIsAuthBoxOpen(true)}
              backgroundColor={"#FDFFFE"}
              _hover={{
                bg: "brand.100",
              }}
              borderRadius={12}
              className={styles.outlineButton}
            >
              Get started
            </Button>
          )}
        </Flex>

        {/* yearly plan  */}
        <Flex className={styles.superchargeContainer}>
          <Flex mt={{ base: "10px", lg: "0px" }} alignItems={"center"}>
            <span className={styles.iconSpan}>
              <BsLightningChargeFill size="24px" color="white" />
            </span>
            <Text
              textAlign={{ base: "center", lg: "start" }}
              lineHeight={{ base: "26px", lg: "38px" }}
              className={styles.superchargeTitle}
            >
              Pro
            </Text>
          </Flex>
          <Box>
            <List spacing={6} color="white">
              <Text className={styles.superchargeDescriptionTop}>
                Everything you love in Basic, plus:
              </Text>
              <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/flushed-check.svg"}
                  />
                  Get unlimited leads on your listings
                </Flex>
                <TooltipCreator
                  label={
                    "There is no limit on the number of leads on your listings which you can receive for free."
                  }
                />
              </MyListItem>
              <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/flushed-check.svg"}
                  />
                  Unlock full lead contact info
                </Flex>
                <TooltipCreator
                  label={
                    "In messaging, listing analytics, and lead alerts, receive full lead contact information including the verified phone number and email."
                  }
                />
              </MyListItem>
              <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/flushed-check.svg"}
                  />
                  Show your expertise with a PRO badge next to your name
                </Flex>
                <TooltipCreator
                  label={
                    "Build credibility by showing that you’re an industry expert. The badge appears next to your name throughout the platform."
                  }
                />
              </MyListItem>
      
              <MyListItem>
                <Flex>
                  <ImageComponent
                    className={styles.checkmarks}
                    src={"/images/pricing/flushed-check.svg"}
                  />
                  Dedicated support from a Customer Success Manager
                </Flex>

                <TooltipCreator
                  label={
                    "Zonado’s marketing team will work as an extension of yours to optimize your listings to get the widest exposure with the right audience."
                  }
                />
              </MyListItem>
              {size.width >= 1040 ? (
                <>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/flushed-check.svg"}
                      />
                      <p>...and more</p>
                    </Flex>
                  </MyListItem>
                  <Text
                    fontSize={"20px"}
                    _hover={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={executeScroll}
                  >
                    See all features <ArrowForwardIcon />
                  </Text>
                </>
              ) : (
                <>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/flushed-check.svg"}
                      />
                      Message/call listing viewers
                    </Flex>

                    <TooltipCreator
                      label={
                        "Zonado Pro users are able to keep tabs on who is expressing interest in their listings and follow up with them as they see fit."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/flushed-check.svg"}
                      />
                      Export leads to Excel file and share with your team
                    </Flex>
                    <TooltipCreator
                      label={
                        "Easily share information on leads, as well as their contact information with other team members."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/flushed-check.svg"}
                      />
                      Access phone & email of the other user in messaging
                    </Flex>
                    <TooltipCreator
                      label={
                        "Convert leads faster by getting instant access to the contact information of the person you’re messaging."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/flushed-check.svg"}
                      />
                      View co-op commission on listings (when available)
                    </Flex>
                    <TooltipCreator
                      label={
                        "View the exact amount or percentage of co-op commission that is being offered on a listing. This information may not be available on all listings."
                      }
                    />
                  </MyListItem>
                  <MyListItem>
                    <Flex>
                      <ImageComponent
                        className={styles.checkmarks}
                        src={"/images/pricing/flushed-check.svg"}
                      />
                      Priority phone support
                    </Flex>
                    <TooltipCreator
                      label={
                        "Zonado Pro users receive priority support for all aspects of the platform."
                      }
                    />
                  </MyListItem>
                </>
              )}
            </List>
          </Box>
          <DashedDivider my={"20px"} />
          {/* <Text className={styles.superchargeDescription}>
            Ideal for professionals
          </Text> */}
          {/* <Text className={styles.superchargeStat}>
              <span className={styles.pricingSpan}>CAD</span> $2,485
              <span className={styles.pricingSpan}>/year (annual)</span>
            </Text> */}
          {profile?.pro && profile?.stripeId ? (
            // && profile?.plan == "Supercharge"
            currentPlanTextWhite
          ) : (
            <>
              <Button
                isLoading={loading == "Monthly"}
                onClick={() => {
                  if (profile) {
                    checkoutMutation.mutate({
                      plan: "Monthly",
                      lookup_key: currentPriceCodes["Monthly"],
                      email: profile?.email,
                      stripeId: profile?.stripeId,
                    });
                  } else {
                    setCheckoutPending(true);
                    setCheckoutPrice(currentPriceCodes["Monthly"]);
                    triggerAuth({
                      hook: "Upgrade button in Pricing",
                      plan: "Monthly",
                      header: "Start your upgrade by creating an account",
                    });
                  }
                }}
                borderRadius={12}
                backgroundColor={"#FDFFFE"}
                _hover={{
                  bg: "brand.100",
                }}
                className={styles.outlineButton}
              >
                <span className={styles.appleSpan}>
                  <span className={styles.appleFormLeft}>
                    Get monthly plan{" "}
                    <ArrowForwardIcon style={{ marginLeft: "5px" }} />
                  </span>
                  <span className={styles.appleFormRight}>
                    CA${currentPrices.Monthly}/mo.
                    {/* <span className={styles.strikeOutSale}>$99/mo.</span> */}
                  </span>
                </span>
              </Button>

              <Button
                isLoading={loading == "Annual"}
                onClick={() => {
                  if (profile) {
                    checkoutMutation.mutate({
                      // plan: "Supercharge",
                      lookup_key: currentPriceCodes["Annual"],
                      email: profile?.email,
                      stripeId: profile?.stripeId,
                    });
                  } else {
                    setCheckoutPending(true);
                    setCheckoutPrice(currentPriceCodes["Annual"]);
                    triggerAuth({
                      hook: "Upgrade button in Pricing",
                      plan: "Annual",
                      header: "Start your upgrade by creating an account",
                    });
                  }
                }}
                borderRadius={12}
                backgroundColor={"#FDFFFE"}
                _hover={{
                  bg: "brand.100",
                }}
                className={styles.outlineButton}
              >
                <span className={styles.appleSpan}>
                  <span className={styles.appleFormLeft}>
                    Get annual plan
                    <ArrowForwardIcon style={{ marginLeft: "5px" }} />
                  </span>
                  <span className={styles.appleFormRight}>
                    CA${currentPrices.Annual} 
                    {!isOnSmallScreen && (
                      <span className={styles.smallSale}>(Save CA${currentPrices.AnnualSavings()})</span>
                    )}
                  </span>
                </span>
              </Button>
              <Box className={styles.demoLinkContainer}>
                <DemoLink
                  href="https://meetings.hubspot.com/harjaap-singh"
                  color="white"
                  target="_blank"
                >
                  Book a Demo
                </DemoLink>
              </Box>
            </>
          )}
        </Flex>
      </Flex>

      <S.LargeDropShadow />
      <S.SmallDropShadow />
    </Box>
    <WrapperStyle>
      {/* <S.SectionHeadingContainer mb="106px">
        <Text>Highlights</Text>
        <Text>Why Zonado Pro?</Text>
      </S.SectionHeadingContainer> */}
      {/* {size.width >= 1040 ? (
        <Flex mb="240px" position={"relative"}>
          <Flex flexDir={"column"} w="44%" mr="108px">
            <Text fontSize={"19px"} lineHeight="34px" pb="64px">
              Zonado Pro is one of the best investments you can make in
              yourself and your business. With a rich feature offering being
              enhanced each month - it keeps giving dividends.
            </Text>
            <Accordion defaultIndex={[0]}>
              <AccordionItem
                maxW="562px"
                w="100%"
                px="20px"
                py="25px"
                boxShadow={visibleAccordionIndex === 0 && accordionBoxShadow}
                borderBottom="1px solid #E2E8F0"
              >
                <AccordionButton
                  fontWeight={"semibold"}
                  width="100%"
                  display="block"
                  _hover={{ color: "#125F3F" }}
                  onClick={() => setVisibleAccordionIndex(0)}
                  color={visibleAccordionIndex === 0 && "#125F3F"}
                  _focus={{
                    outline: "none",
                  }}
                >
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Icon flex="0.5" as={RiProfileFill} h="30px" />
                    <Text
                      flex="3"
                      fontSize={"19px"}
                      lineHeight="23px"
                      textAlign={"left"}
                    >
                      Unlock full lead contact information
                    </Text>
                  </Flex>
                </AccordionButton>
                <AccordionPanel fontSize={"16px"} lineHeight="24px">
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Box flex="0.5"></Box>
                    <Box flex="3">
                      <Text>
                        Instantly access the verified phone number and
                        validated email address of the person you’re
                        messaging.
                      </Text>
                      <Box mt="15px" as="button" onClick={onOpen}>
                        <Text fontWeight={"medium"} as="span">
                          Upgrade now
                        </Text>
                        <ArrowForwardIcon />
                      </Box>
                    </Box>
                  </Flex>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem
                maxW="562px"
                w="100%"
                px="20px"
                py="25px"
                boxShadow={visibleAccordionIndex === 1 && accordionBoxShadow}
                borderBottom="1px solid #E2E8F0"
              >
                <AccordionButton
                  fontWeight={"semibold"}
                  width="100%"
                  display="block"
                  _hover={{ color: "#125F3F" }}
                  onClick={() => setVisibleAccordionIndex(1)}
                  color={visibleAccordionIndex === 1 && "#125F3F"}
                  _focus={{
                    outline: "none",
                  }}
                >
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Icon
                      flex="0.5"
                      as={RiUserReceivedFill}
                      w="30px"
                      h="30px"
                    />
                    <Text
                      flex="3"
                      fontSize={"19px"}
                      lineHeight="23px"
                      textAlign="left"
                    >
                      Access significantly enhanced lead tracking
                    </Text>
                  </Flex>
                </AccordionButton>
                <AccordionPanel fontSize={"16px"} lineHeight="24px">
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Box flex="0.5"></Box>
                    <Box flex="3">
                      <Text>
                        Get alerts when buyer and tenants take any action on
                        your listing, contact your leads, export lead reports,
                        and more.
                      </Text>
                      <Box mt="15px" as="button" onClick={onOpen}>
                        <Text fontWeight={"medium"} as="span">
                          Upgrade now
                        </Text>
                        <ArrowForwardIcon />
                      </Box>
                    </Box>
                  </Flex>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem
                maxW="562px"
                w="100%"
                px="20px"
                py="25px"
                boxShadow={visibleAccordionIndex === 2 && accordionBoxShadow}
                borderBottom="1px solid #E2E8F0"
              >
                <AccordionButton
                  fontWeight={"semibold"}
                  display="block"
                  width="100%"
                  _hover={{ color: "#125F3F" }}
                  onClick={() => setVisibleAccordionIndex(2)}
                  color={visibleAccordionIndex === 2 && "#125F3F"}
                  _focus={{
                    outline: "none",
                  }}
                >
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Icon flex="0.5" as={MdSendToMobile} w="30px" h="30px" />
                    <Text
                      flex="3"
                      fontSize={"19px"}
                      lineHeight="23px"
                      textAlign="left"
                    >
                      Message Want posters, enhance your deal flow
                    </Text>
                  </Flex>
                </AccordionButton>
                <AccordionPanel fontSize={"16px"} lineHeight="24px">
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Box flex="0.5"></Box>
                    <Box flex="3">
                      <Text>
                        Take your listing to buyers and tenants who have
                        already expressed an interest in it through a Want. Or
                        simply work with a Want poster to help them find a
                        property.
                      </Text>
                      <Box mt="15px" as="button" onClick={onOpen}>
                        <Text fontWeight={"medium"} as="span">
                          Upgrade now
                        </Text>
                        <ArrowForwardIcon />
                      </Box>
                    </Box>
                  </Flex>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem
                maxW="562px"
                w="100%"
                px="20px"
                py="25px"
                boxShadow={visibleAccordionIndex === 3 && accordionBoxShadow}
                borderBottom="1px solid #E2E8F0"
              >
                <AccordionButton
                  display="block"
                  width="100%"
                  fontWeight={"semibold"}
                  _hover={{ color: "#125F3F" }}
                  onClick={() => setVisibleAccordionIndex(3)}
                  color={visibleAccordionIndex === 3 && "#125F3F"}
                  _focus={{
                    outline: "none",
                  }}
                >
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Icon
                      flex="0.5"
                      as={BsFillFilterCircleFill}
                      w="30px"
                      h="30px"
                    />
                    <Text
                      flex="3"
                      fontSize={"19px"}
                      lineHeight="23px"
                      textAlign="left"
                    >
                      Unlock PRO-only search filters
                    </Text>
                  </Flex>
                </AccordionButton>
                <AccordionPanel fontSize={"16px"} lineHeight="24px">
                  <Flex justifyContent={"space-between"} alignItems="center">
                    <Box flex="0.5"></Box>
                    <Box flex="3">
                      <Text>
                        Free users do not have access to the search filters
                        that PRO members do. Get ahead of the competition with
                        smarter filtering.
                      </Text>
                      <Box mt="15px" as="button" onClick={onOpen}>
                        <Text fontWeight={"medium"} as="span">
                          Upgrade now
                        </Text>
                        <ArrowForwardIcon />
                      </Box>
                    </Box>
                  </Flex>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </Flex>
          <Box pos={"absolute"} left="50%">
            <Image
              src={accordionData[visibleAccordionIndex]}
              width={661}
              height={734}
              layout="intrinsic"
            />
          </Box>
        </Flex>
      ) : (
        <Flex mb="240px">
          <Flex flexDir={"column"} alignItems={"center"}>
            <Text fontSize={"19px"} lineHeight="34px" pb="64px">
              Zonado Pro is one of the best investments you can make in
              yourself and your business. With a rich feature offering being
              enhanced each month - it keeps giving dividends.
            </Text>
            <Accordion defaultIndex={[0]} maxW="841px">
              <AccordionItem
                boxShadow={visibleAccordionIndex === 0 && accordionBoxShadow}
                borderTopWidth="0"
                borderBottom={"1px solid #E2E8F0"}
              >
                <ResponsiveAccordionButton
                  accordionIndex={0}
                  buttonText="Unlock full lead contact information"
                  icon={RiProfileFill}
                />
                <ResponsiveAccordionPanel
                  accordionIndex={0}
                  imageWidth={661}
                  imageHeight={724}
                  panelImage={accordionData[0]}
                  panelText="Instantly access the verified phone number and validated
                  email address of the person you’re messaging."
                />
              </AccordionItem>
              <AccordionItem
                boxShadow={visibleAccordionIndex === 1 && accordionBoxShadow}
                borderTopWidth="0"
                borderBottom={"1px solid #E2E8F0"}
              >
                <ResponsiveAccordionButton
                  buttonText="Access significantly enhanced lead tracking"
                  icon={RiUserReceivedFill}
                  accordionIndex={1}
                />
                <ResponsiveAccordionPanel
                  panelText="Get alerts when buyer and tenants take any action on your
                  listing, contact your leads, export lead reports, and more."
                  accordionIndex={1}
                  panelImage={accordionData[1]}
                  imageHeight={661}
                  imageWidth={724}
                />
              </AccordionItem>
              <AccordionItem
                boxShadow={visibleAccordionIndex === 2 && accordionBoxShadow}
                borderTopWidth="0"
                borderBottom={"1px solid #E2E8F0"}
              >
                <ResponsiveAccordionButton
                  accordionIndex={2}
                  buttonText="Message Want posters, enhance your deal flow"
                  icon={MdSendToMobile}
                />
                <ResponsiveAccordionPanel
                  accordionIndex={2}
                  imageHeight={661}
                  imageWidth={724}
                  panelImage={accordionData[2]}
                  panelText="Take your listing to buyers and tenants who have already
                  expressed an interest in it through a Want. Or simply work
                  with a Want poster to help them find a property."
                />
              </AccordionItem>
              <AccordionItem
                boxShadow={visibleAccordionIndex === 3 && accordionBoxShadow}
                borderTopWidth="0"
                borderBottom={"1px solid #E2E8F0"}
              >
                <ResponsiveAccordionButton
                  accordionIndex={3}
                  buttonText="Unlock PRO-only search filters"
                  icon={BsFillFilterCircleFill}
                />
                <ResponsiveAccordionPanel
                  accordionIndex={3}
                  imageWidth={661}
                  imageHeight={724}
                  panelImage={accordionData[3]}
                  panelText="Free users do not have access to the search filters that PRO
                 member do. Get ahead of the competition with smarter
                 filtering."
                />
              </AccordionItem>
            </Accordion>
          </Flex>
        </Flex>
      )} */}
      {size.width >= 1040 && (
        <>
          <S.SectionHeadingContainer mb="100px" ref={myRef}>
            <Text>Features</Text>
            <Text>Pro Features at a Glance</Text>
          </S.SectionHeadingContainer>
          <Flex
            border={"1px solid #dce2e4"}
            p="41px"
            justifyContent={"space-evenly"}
            mb="240px"
          >
            <Flex flexDir={"column"} maxW="445px" w="100%">
              
              {/* Listings and leads */}
              <Box mb="38px">
                <Text fontSize={"19px"} fontWeight={500} lineHeight="48px">
                  Add listings and get leads
                </Text>
                <S.FeaturesTableDivider mb />
                <S.FeaturesTableText>
                  Upload unlimited listings
                </S.FeaturesTableText>
                <S.FeaturesTableText>
                  Get leads on your listings
                </S.FeaturesTableText>
                <S.FeaturesTableText>
                  Get SMS alerts for new messages
                </S.FeaturesTableText>
                <S.FeaturesTableText>
                  Access listings analytics
                </S.FeaturesTableText>
                <S.FeaturesTableText green>
                  Unlock full lead contact information
                </S.FeaturesTableText>
                <S.FeaturesTableText green>
                  Message/Call listing viewers
                </S.FeaturesTableText>
                <S.FeaturesTableText green>
                  Export leads to Excel and share with team
                </S.FeaturesTableText>
              </Box>
              {/* Messaging */}
              <Box mb="38px">
                <Text fontSize={"19px"} fontWeight={500} lineHeight="48px">
                  Messaging
                </Text>
                <S.FeaturesTableDivider mb />
                <S.FeaturesTableText>
                  Send and receive messages
                </S.FeaturesTableText>
                <S.FeaturesTableText green>
                  Access phone & email of the other user
                </S.FeaturesTableText>
              </Box>
              <Box mb="38px">
                <Text fontSize={"19px"} fontWeight={500} lineHeight="48px">
                  Promote your services
                </Text>
                <S.FeaturesTableDivider mb />
                <S.FeaturesTableText green>
                  Display a PRO badge on your profile and listings
                </S.FeaturesTableText>
              </Box>
    
              <Box>
                <Text fontSize={"19px"} fontWeight={500} lineHeight="48px">
                  Customer support
                </Text>
                <S.FeaturesTableDivider mb />
                <S.FeaturesTableText>
                  Email and chat support
                </S.FeaturesTableText>
                <S.FeaturesTableText green>
                  Priority phone support
                </S.FeaturesTableText>
                <S.FeaturesTableDivider mt />
              </Box>
            </Flex>
            <Flex flexDir={"column"} maxW="232px" w="100%">
              <Box mb="38px">
                <Text
                  fontSize={"19px"}
                  fontWeight={500}
                  lineHeight="48px"
                  textAlign={"center"}
                >
                  Basic
                </Text>
                
                <S.FeaturesTableDivider mb grey />
                <Flex
                  flexDir={"column"}
                  alignItems="center"
                  gap="22px"
                  mt={"22px"}
                  mb="106px"
                >
                  <CheckIcon w={"14px"} h={"10px"} />
                  5 leads
                  <CheckIcon w={"14px"} h={"10px"} />
                  <CheckIcon w={"14px"} h={"10px"} />
                  <Box w={"14px"} h="10px" />
                  <Box w={"14px"} h="10px" />
                  <Box w={"14px"} h="10px" />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  mb="101px"
                >
                  <CheckIcon w={"14px"} h={"10px"} />
                  <Box w={"14px"} h="10px" />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  mb="102px"
                >
                  <CheckIcon w={"14px"} h={"10px"} />
                  <CheckIcon w={"14px"} h={"10px"} />
                  <CheckIcon w={"14px"} h={"10px"} />
                  <CheckIcon w={"14px"} h={"10px"} />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  mb="100px"
                >
                  <Box w={"14px"} h="10px" />
                </Flex>
              
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  pb="6px"
                >
                  <CheckIcon w={"14px"} h={"10px"} />
                  <Box w={"14px"} h="10px" />
                </Flex>
                <S.FeaturesTableDivider grey mt mb />
                <Flex flexDir="column" alignItems={"center"}>
                  <Text
                    color="#646F79"
                    fontSize={"14px"}
                    fontWeight={500}
                    lineHeight="20px"
                    mt="15px"
                    mb="21px"
                  >
                    BASIC
                  </Text>
                  <Link href="/listings">

                    <Button
                      variant={"outline"}
                      color="#273240"
                      borderColor={"#273240"}
                      fontWeight={500}
                      w="180px"
                      height="50px"
                      mb="39px"
                    >
                      Go to Zonado
                    </Button>

                  </Link>
                </Flex>
              </Box>
            </Flex>
            <Flex
              flexDir={"column"}
              bgColor="#DFF1E5"
              borderRadius={"7px"}
              maxW="232px"
              w="100%"
            >
              <Box mb="38px">
                <Text
                  fontSize={"19px"}
                  fontWeight={500}
                  lineHeight="48px"
                  textAlign={"center"}
                >
                  Pro
                </Text>
               
                <S.FeaturesTableDivider mb grey />
                <Flex
                  flexDir={"column"}
                  alignItems="center"
                  gap="22px"
                  mt={"22px"}
                  mb="106px"
                >
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <span style={{color: "#125F3F", fontWeight: "bold"}}>Unlimited leads</span>
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  mb="101px"
                >
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  mb="102px"
                >
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  mb="100px"
                >
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                </Flex>
                <S.FeaturesTableDivider grey mb />
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  gap="22px"
                  mt={"22px"}
                  pb="6px"
                >
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                  <CheckIcon w={"14px"} h={"10px"} color="#125F3F" />
                </Flex>
                <S.FeaturesTableDivider grey mt mb />
                <Flex flexDir="column" alignItems={"center"}>
                  <Text
                    color="#646F79"
                    fontSize={"14px"}
                    fontWeight={500}
                    lineHeight="20px"
                    mt="15px"
                    mb="21px"
                  >
                    PRO
                  </Text>
                  <Button
                    color="white"
                    bgColor="#145338"
                    fontWeight={500}
                    w="180px"
                    height="50px"
                    _hover={{
                      backgroundColor: "#125f3f90",
                    }}
                    mb="39px"
                    onClick={onOpen}
                  >
                    Upgrade Now
                  </Button>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </>
      )}
    </WrapperStyle>
    <Box bgColor="#0A3423">
      <WrapperStyle>
        <S.SectionHeadingContainer invert mb="93px" pt="128px">
          <Text>Our focus</Text>
          <Text>Zonado is an extension of your team</Text>
        </S.SectionHeadingContainer>
        <S.OurFocusGrid>
          <S.OurFocusGridItem>
            <Image
              src="/images/pro/high-quality-leads.png"
              width={380}
              height={240}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
            <Text>Highest quality leads</Text>
            <Text>
              The contact information of every lead you receive on Zonado
              comes validated and verified. Say goodbye to misspelled email
              addresses, mis-typed phone numbers, and missed opportunities.
            </Text>
          </S.OurFocusGridItem>
          <S.OurFocusGridItem>
            <Image
              src="/images/pro/high-transaction-intent.svg"
              width={380}
              height={240}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
            <Text>High transaction intent</Text>
            <Text>
              Over 70% of the traffic on Zonado is here with the active intent
              to transact. This means ‘tire-kickers’ are replaced with serious
              conversations that get your deal closed.
            </Text>
          </S.OurFocusGridItem>
          <S.OurFocusGridItem>
            <Image
              src="/images/pro/our-team.svg"
              width={380}
              height={240}
              style={{
                maxWidth: "100%",
                height: "auto"
              }} />
            <Text>Our team is your team</Text>
            <Text>
              Zonado’s marketing team works closely with you to ensure that
              your listings are reaching the right audiences and are are set
              up for success.
            </Text>
          </S.OurFocusGridItem>
          <Flex justifyContent={"center"} gridColumn="1/-1">
            <S.CTAButton onClick={onOpen} color="white">
              Upgrade to Zonado Pro
            </S.CTAButton>
          </Flex>
        </S.OurFocusGrid>
      </WrapperStyle>
    </Box>
    <WrapperStyle>
      <S.SectionHeadingContainer mb="87px">
        <Text>Our partners</Text>
        <Text>Loved by 400+ teams across Canada</Text>
      </S.SectionHeadingContainer>
      <Box mb="240px">
        <ElasticCarousel
          itemsToShow={1}
          itemsToScroll={1}
          isRTL={false}
          pagination={false}
          enableAutoPlay
          autoPlaySpeed={8000}
          tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
          transitionMs={2000}
          ref={logoCarouselRef}
          onPrevStart={onPrevPopStart}
          onNextStart={onNextPopStart}
          onNextEnd={({ index }) => {
            clearTimeout(logoCarouselResetTimeout);
            if (index + 1 === logoCarouselTotalPages) {
              if (logoCarouselRef?.current?.goTo) {
                logoCarouselResetTimeout = setTimeout(() => {
                  if (logoCarouselRef?.current?.goTo) {
                    logoCarouselRef.current.goTo(0);
                  }
                }, 8000);
              }
            }
          }}
          renderArrow={({ type, onClick }) => {
            return (
              <S.Rand>
                <IconButton
                  fontSize={"25px"}
                  boxSize={"40px"}
                  isRound
                  fontWeight="500"
                  variant="outline"
                  color={"#125f3f"}
                  borderColor={"#125f3f"}
                  _hover={{
                    bg: "#89AF9F",
                  }}
                  aria-label="View next/previous set of partners"
                  icon={
                    type === "PREV" ? (
                      <ChevronLeftIcon />
                    ) : (
                      <ChevronRightIcon />
                    )
                  }
                  onClick={onClick}
                />
              </S.Rand>
            );
          }}
        >
          <Image
            src="/images/pro/partners-logos-1.svg"
            width={514}
            height={63}
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
          <Image
            src="/images/pro/partners-logos-2.svg"
            width={514}
            height={39}
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
          <Image
            src="/images/pro/partners-logos-3.svg"
            width={514}
            height={38}
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
          <Image
            src="/images/pro/partners-logos-4.svg"
            width={514}
            height={41}
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
          <Image
            src="/images/pro/partners-logos-5.svg"
            width={514}
            height={50}
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
        </ElasticCarousel>
        <Flex justifyContent={"center"} mt="50px">
          <S.CTAButton onClick={onOpen} color="black">
            Upgrade to Zonado Pro
          </S.CTAButton>
        </Flex>
      </Box>
    </WrapperStyle>
    <Box bgColor={"#0A3423"} mb="240px">
      <WrapperStyle>
        <ElasticCarousel
          ref={userCarouselRef}
          isRTL={false}
          pagination={false}
          itemsToScroll={1}
          itemsToShow={1}
          enableAutoPlay
          autoPlaySpeed={8000}
          tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
          transitionMs={2000}
          onNextStart={onNextUserStart}
          onPrevStart={onPrevUserStart}
          onNextEnd={({ index }) => {
            clearTimeout(userCarouselResetTimeout);
            if (index + 1 === userCarouselTotalPages) {
              if (userCarouselRef?.current?.goTo) {
                userCarouselResetTimeout = setTimeout(() => {
                  if (userCarouselRef?.current?.goTo) {
                    userCarouselRef.current.goTo(0);
                  }
                }, 8000);
              }
            }
          }}
          renderArrow={({ type, onClick }) => {
            return (
              <Flex alignItems={"center"}>
                <IconButton
                  fontSize={"25px"}
                  boxSize={"40px"}
                  isRound
                  fontWeight="500"
                  variant="solid"
                  color={"white"}
                  border="1px solid white"
                  _hover={{
                    bg: "#859A91",
                  }}
                  bg="#0A3423"
                  aria-label="View next/previous testimonial"
                  icon={
                    type === "PREV" ? (
                      <ChevronLeftIcon />
                    ) : (
                      <ChevronRightIcon />
                    )
                  }
                  onClick={onClick}
                />
              </Flex>
            );
          }}
        >
          {userData.map((item, index) => {
            return (
              (<Flex
                flexDir={size.width >= 960 ? "row" : "column"}
                key={index}
                p="225px 0 187px 0"
                alignItems={"center"}
              >
                <Image
                  src={item.image}
                  width={300}
                  height={401}
                  style={{
                    borderRadius: "12px",
                    maxWidth: "100%",
                    height: "auto"
                  }} />
                <Flex
                  flexDir={"column"}
                  pl={size.width >= 960 && "52px"}
                  justifyContent={"center"}
                  mt="40px"
                >
                  <Box alignSelf="flex-start">
                    <Image
                      src="/images/pro/quote-left.svg"
                      width={size.width >= 480 ? 40 : 30}
                      height={size.width >= 480 ? 40 : 30} />
                  </Box>
                  <S.UserCarouselTestimonial>
                    {item.testimonial}
                  </S.UserCarouselTestimonial>
                  <Text fontSize={"16px"} lineHeight="26px" color="white">
                    {item.info}
                  </Text>
                </Flex>
              </Flex>)
            );
          })}
        </ElasticCarousel>
      </WrapperStyle>
    </Box>
    <WrapperStyle>
      <S.SectionHeadingContainer mb="112px">
        <Text>Get started</Text>
        <Text>
          Every successful professional on Zonado started with this step:
        </Text>
      </S.SectionHeadingContainer>
      <Box mb="240px">
        <Flex
          flexDir={{ base: "column", md: "row" }}
          w={"100%"}
          justifyContent={"space-between"}
        >
          <Flex w={{ base: "100%", md: "40%" }} flexDir={"column"}>
            <Text
              textAlign={{ base: "center", md: "start" }}
              fontSize={{ base: "34px", lg: "44px" }}
              lineHeight={{ base: "42px", lg: "52px" }}
              fontWeight={500}
            >
              Contact Us
            </Text>
            <Text
              textAlign={{ base: "center", md: "start" }}
              mt={{ base: "20px", lg: "30px" }}
              pb={"30px"}
              borderBottomWidth={{ base: "0", lg: "1px" }}
              color={"gray.500"}
              borderColor={"gray.200"}
              fontSize={{ md: "17px" }}
              lineHeight={{ md: "29px" }}
            >
              If you're curious about Zonado Pro or have any questions, please
              feel free to reach out.
            </Text>

            <Box
              display={{ base: "none", md: "block" }}
              my={{ base: "50px", md: "0" }}
            >
              <Box mt={"50px"}>
                <Box display={"flex"}>
                  <ImageComponent
                    src={"/images/newLanding/sendEmail.svg"}
                    width={"30px"}
                    height={"30px"}
                    mr={"20px"}
                  />
                  <Box>
                    <Text
                      fontSize={{ md: "17px" }}
                      lineHeight={{ md: "22px" }}
                      fontWeight={"500"}
                    >
                      Send us an email
                    </Text>

                    <a href={"mailto:hello@zonado.com"}>
                      <Text
                        fontSize={{ md: "17px" }}
                        lineHeight={{ md: "22px" }}
                        fontWeight={"500"}
                        color={"brand.900"}
                      >
                        hello@zonado.com
                      </Text>
                    </a>
                  </Box>
                </Box>
              </Box>

              <Box mt={{ base: "30px", lg: "50px" }}>
                <Box display={"flex"}>
                  <ImageComponent
                    src={"/images/newLanding/callIcon.svg"}
                    width={"30px"}
                    height={"30px"}
                    mr={"20px"}
                  />
                  <Box>
                    <Text
                      fontSize={{ md: "17px" }}
                      lineHeight={{ md: "22px" }}
                      fontWeight={"500"}
                    >
                      Call us
                    </Text>

                    <a href={"tel:18847540007"}>
                      <Text
                        fontSize={{ md: "17px" }}
                        lineHeight={{ md: "22px" }}
                        fontWeight={"500"}
                        color={"brand.900"}
                      >
                        1 (855) 667 7308
                      </Text>
                    </a>
                  </Box>
                </Box>
              </Box>

              {/* <Box mt={{ base: "30px", lg: "50px" }}>
                <Box display={"flex"}>
                  <ImageComponent
                    src={"/images/newLanding/chatIcon.svg"}
                    width={"30px"}
                    height={"30px"}
                    mr={"20px"}
                  />
                  <Box>
                    <Text
                      fontSize={{ md: "17px" }}
                      lineHeight={{ md: "22px" }}
                      fontWeight={"500"}
                    >
                      Chat with us
                    </Text>
                    <Text
                      fontSize={{ md: "17px" }}
                      lineHeight={{ md: "22px" }}
                      fontWeight={"500"}
                      color={"brand.900"}
                    >
                      Use chat below
                    </Text>
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Flex>

          <Formik
            initialValues={{
              name: profile ? profile.fullName : "",
              phone: profile && profile.phone ? profile.phone : "",
              email: profile && profile.email ? profile.email : "",
              company: profile && profile.brokerage ? profile.brokerage : "",
              message: "",
            }}
            validationSchema={MessageSchema}
            onSubmit={async (values, { setSubmitting }) => {
              if (messageStatus !== "loading") {
                mutation.mutate({
                  ...values,
                });

                setSubmitting(false);
              }
            }}
          >
            {({
              isSubmitting,
              isValid,
              handleChange,
              values,
              handleSubmit,
            }) => (
              <>
                {messageStatus !== "success" && (
                  <Flex w={{ md: "50%" }}>
                    <form onSubmit={handleSubmit}>
                      <Box
                        shadow={"lg"}
                        w={"100%"}
                        p={"50px"}
                        display={"flex"}
                        flexWrap={"wrap"}
                        justifyContent={"space-between"}
                      >
                        <Field
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Name"
                          component={ContactInput}
                          rounded={"28px"}
                        />

                        <Field
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Email"
                          component={ContactInput}
                          rounded={"28px"}
                        />

                        <Field
                          type="number"
                          name="phone"
                          id="phone"
                          placeholder="Phone (optional)"
                          component={ContactInput}
                          rounded={"28px"}
                        />

                        <Field
                          type="text"
                          name="company"
                          id="company"
                          placeholder="Company (optional)"
                          component={ContactInput}
                          rounded={"28px"}
                        />

                        <Field
                          type="text"
                          name="message"
                          id="message"
                          placeholder="How can we help"
                          component={ContactTextArea}
                        />

                        <PrimaryButton
                          type="submit"
                          isLoading={messageStatus === "loading"}
                          loadingText="Sending Message"
                          label={"Contact Us"}
                          mt={"28px"}
                          ml={{ base: "auto", lg: 0 }}
                          mr={"auto"}
                        />
                      </Box>
                    </form>
                  </Flex>
                )}

                {messageStatus === "success" && (
                  <Box>
                    <Alert status="success" variant="subtle">
                      <AlertIcon />
                      Thanks for reaching out! We'll be in touch soon
                    </Alert>
                  </Box>
                )}

                {messageStatus === "error" && (
                  <Message error noShow={undefined} success={undefined}>
                    There was an error, please try again later.
                  </Message>
                )}
              </>
            )}
          </Formik>
        </Flex>

        <Box display={{ base: "block", md: "none" }}>
          <Box mt={"50px"}>
            <Box display={"flex"}>
              <ImageComponent
                src={"/images/newLanding/sendEmail.svg"}
                width={"30px"}
                height={"30px"}
                mr={"20px"}
              />
              <Box>
                <Text
                  fontSize={{ md: "17px" }}
                  lineHeight={{ md: "22px" }}
                  fontWeight={"500"}
                >
                  Send us an email
                </Text>

                <a href={"mailto:hello@zonado.com"}>
                  <Text
                    fontSize={{ md: "17px" }}
                    lineHeight={{ md: "22px" }}
                    fontWeight={"500"}
                    color={"brand.900"}
                  >
                    hello@zonado.com
                  </Text>
                </a>
              </Box>
            </Box>
          </Box>

          <Box mt={{ base: "30px", lg: "50px" }}>
            <Box display={"flex"}>
              <ImageComponent
                src={"/images/newLanding/callIcon.svg"}
                width={"30px"}
                height={"30px"}
                mr={"20px"}
              />
              <Box>
                <Text
                  fontSize={{ md: "17px" }}
                  lineHeight={{ md: "22px" }}
                  fontWeight={"500"}
                >
                  Call us
                </Text>

                <a href={"tel:18847540007"}>
                  <Text
                    fontSize={{ md: "17px" }}
                    lineHeight={{ md: "22px" }}
                    fontWeight={"500"}
                    color={"brand.900"}
                  >
                    1 (855) 667 7308
                  </Text>
                </a>
              </Box>
            </Box>
          </Box>

          <Box mt={{ base: "30px", lg: "50px" }}>
            <Box display={"flex"}>
              <ImageComponent
                src={"/images/newLanding/chatIcon.svg"}
                width={"30px"}
                height={"30px"}
                mr={"20px"}
              />
              <Box>
                <Text
                  fontSize={{ md: "17px" }}
                  lineHeight={{ md: "22px" }}
                  fontWeight={"500"}
                >
                  Chat with us
                </Text>
                <Text
                  fontSize={{ md: "17px" }}
                  lineHeight={{ md: "22px" }}
                  fontWeight={"500"}
                  color={"brand.900"}
                >
                  Use chat below
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </WrapperStyle>
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bgColor={"#244339"}>
        <ModalHeader color="white">Zonado Pro Plans</ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody>
          {profile?.pro ? (
            <Text marginY="43px" textAlign="center" color="#fff">
              You are currently on Zonado Pro
            </Text>
          ) : (
            <>
              <Button
                w="100%"
                isLoading={loading == "Monthly"}
                onClick={() => {
                  if (profile) {
                    checkoutMutation.mutate({
                      plan: "Monthly",
                      lookup_key: currentPriceCodes["Monthly"],
                      email: profile?.email,
                      stripeId: profile?.stripeId,
                    });
                  } else {
                    setCheckoutPending(true);
                    setCheckoutPrice(currentPriceCodes["Monthly"]);
                    triggerAuth({
                      hook: "Upgrade button in Pricing",
                      plan: "Monthly",
                      header: "Start your upgrade by creating an account",
                    });
                  }
                }}
                borderRadius={12}
                backgroundColor={"#FDFFFE"}
                _hover={{
                  bg: "brand.100",
                }}
                className={styles.outlineButton}
              >
                <span className={styles.appleSpan}>
                  <span className={styles.appleFormLeft}>
                    Get monthly plan{" "}
                    <ArrowForwardIcon style={{ marginLeft: "5px" }} />
                  </span>
                  <span className={styles.appleFormRight}>
                    CA${currentPrices.Monthly}/mo.
                    {/* <span className={styles.strikeOutSale}>$99/mo.</span> */}
                  </span>
                </span>
              </Button>

              <Button
                w="100%"
                isLoading={loading == "Annual"}
                onClick={() => {
                  if (profile) {
                    checkoutMutation.mutate({
                      // plan: "Supercharge",
                      lookup_key: currentPriceCodes["Annual"],
                      email: profile?.email,
                      stripeId: profile?.stripeId,
                    });
                  } else {
                    setCheckoutPending(true);
                    setCheckoutPrice(currentPriceCodes["Annual"]);
                    triggerAuth({
                      hook: "Upgrade button in Pricing",
                      plan: "Annual",
                      header: "Start your upgrade by creating an account",
                    });
                  }
                }}
                borderRadius={12}
                backgroundColor={"#FDFFFE"}
                _hover={{
                  bg: "brand.100",
                }}
                className={styles.outlineButton}
              >
                <span className={styles.appleSpan}>
                  <span className={styles.appleFormLeft}>
                    Get annual plan
                    <ArrowForwardIcon style={{ marginLeft: "5px" }} />
                  </span>
                  <span className={styles.appleFormRight}>
                    CA${currentPrices.Annual}
                    {size?.width > 407 && (
                      <span className={styles.smallSale}>(Save CA${currentPrices.AnnualSavings()})</span>
                    )}
                  </span>
                </span>
              </Button>
              <Box className={styles.demoLinkContainer}>
                <DemoLink
                  href="https://meetings.hubspot.com/harjaap-singh"
                  color="white"
                  target="_blank"
                >
                  Book a Demo
                </DemoLink>
              </Box>
            </>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
    {/* Sticky review */}
    <a
      onClick={() => {
        clientAnalytics.track("Review link visited on LP");
      }}
      href="https://goo.gl/maps/YYngTFK3k7PVwHfm7"
      target="_blank"
    >
      <StickyReviews right={true}>
        <ReviewLogo>
          <MiniLogo src={"/images/lp/miniLogo.svg"} alt="Zonado Logo" />
        </ReviewLogo>

        <ReviewRightSide>
          <RightSideTop>Zonado's Reviews</RightSideTop>
          <StarsHolder>
            <StarSpan>
              <StarFlexer>
                {[...Array(5)].map((e, i) => (
                  <StarContainer key={i}>
                    <AiFillStar color="#f2962d" size="16px" />
                  </StarContainer>
                ))}
              </StarFlexer>
            </StarSpan>
            <RatingHolder>(5.0)</RatingHolder>
          </StarsHolder>
        </ReviewRightSide>
      </StickyReviews>
    </a>
  </>);
};

Plans.newLayout = true;
Plans.faq = plansFAQ;

export default Plans;
export async function getInitialProps(context) {
  const { req, query, res, asPath, pathname } = context;
  let host = req.headers.host; // will give you localhost:3000
  return {
    host,
  };
}
